var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomaticDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2405_38902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1227 2.44788C5.64125 1.87652 6.30875 1.56127 7 1.56127C7.69125 1.56127 8.35875 1.87652 8.87731 2.44788C8.99104 2.57319 9.1645 2.55953 9.26475 2.41737C9.365 2.27521 9.35408 2.05837 9.24034 1.93306C8.62151 1.25121 7.82493 0.875 7 0.875C6.17508 0.875 5.37849 1.25121 4.75966 1.93306C4.64593 2.05837 4.635 2.27521 4.73525 2.41737C4.8355 2.55953 5.00897 2.57319 5.1227 2.44788Z",
    fill: "#023E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46235 3.17026C6.61345 3.03607 6.79422 2.96397 6.97958 2.96397C7.16494 2.96397 7.3457 3.03607 7.49681 3.17026C7.6204 3.28002 7.79177 3.24375 7.87958 3.08926C7.96739 2.93477 7.93838 2.72056 7.81479 2.6108C7.57078 2.39411 7.27889 2.2777 6.97958 2.2777C6.68027 2.2777 6.38837 2.39411 6.14437 2.6108C6.02078 2.72056 5.99177 2.93477 6.07958 3.08926C6.16738 3.24375 6.33875 3.28002 6.46235 3.17026Z",
    fill: "#023E8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55556 4.0605C1.55556 3.84572 1.72967 3.67161 1.94444 3.67161L12.0556 3.67161C12.2703 3.67161 12.4444 3.84572 12.4444 4.0605L12.4431 12.6161H13.6111C13.8259 12.6161 14 12.7902 14 13.0049C14 13.2197 13.8259 13.3938 13.6111 13.3938L0.388889 13.3938C0.174111 13.3938 0 13.2197 0 13.0049C0 12.7902 0.174111 12.6161 0.388889 12.6161H1.55689L1.55556 4.0605ZM11.6667 7.90078L11.668 12.6161L2.33201 12.6161C2.33201 12.6161 2.33334 9.45762 2.33334 7.90078L11.6667 7.90078ZM11.6667 5.35938V4.44939L2.33334 4.44939V5.35938H11.6667ZM11.6667 6.23438H2.33334V7.123L11.6667 7.123V6.23438Z",
    fill: "#023E8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2405_38902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticDoor);
export default __webpack_public_path__ + "static/media/AutomaticDoor.13b5640314b3d5c80808394da5b2bcee.svg";
export { ForwardRef as ReactComponent };